import React, { Component } from 'react';
import ReportExplainer from '../index';
import { withTranslation } from 'react-i18next';

class ReportExplainerCompetitiveAnalysis extends Component {
    constructor() {
        super();

        this.state = {
            showMore: false,
        };
    }

    render() {
        const { t } = this.props;

        const text = (
            <div className="report-explainer-custom">
                <div className={!this.state.showMore ? 'with-show-more' : ''}>
                    {t('discover.authors.reportExplainer.text1')}
                </div>
                {this.state.showMore ? (
                    <>
                        <div>
                            <span className="report-subtitle">
                                {' '}
                                {t('discover.authors.reportExplainer.text2Header')}
                            </span>
                        </div>
                        <div>
                            <ul>
                                <li>{t('discover.authors.reportExplainer.text2')}</li>
                                <li>{t('discover.authors.reportExplainer.text3')}</li>
                                <li>{t('discover.authors.reportExplainer.text4')}</li>
                                <li>{t('discover.authors.reportExplainer.text5')}</li>
                                <li>{t('discover.authors.reportExplainer.text6')}</li>
                                <li>{t('discover.authors.reportExplainer.text7')}</li>
                            </ul>
                        </div>
                        <div>
                            <span className="report-subtitle">
                                {' '}
                                {t('discover.authors.reportExplainer.text8Header')}
                            </span>
                        </div>
                        <div>
                            <ul>
                                <li>{t('discover.authors.reportExplainer.text8')}</li>
                                <li>{t('discover.authors.reportExplainer.text9')}</li>
                                <li> {t('discover.authors.reportExplainer.text10')}</li>
                            </ul>
                        </div>
                        <div>
                            <span className="report-subtitle">
                                {' '}
                                {t('discover.authors.reportExplainer.text11Header')}
                            </span>{' '}
                            {t('discover.authors.reportExplainer.text11')}
                        </div>
                        <div>{t('discover.authors.reportExplainer.text12')}</div>
                        <div className="show-more-btn">
                            <button onClick={() => this.setState({ showMore: false })}>
                                <i className="icon-arrow-up" />
                                {t('discover.authors.reportExplainer.show_less')}
                            </button>
                        </div>
                    </>
                ) : (
                    <div className="show-more-btn absolute-btn">
                        <button onClick={() => this.setState({ showMore: true })}>
                            <i className="icon-arrow-down" />
                            {t('discover.authors.reportExplainer.show_more')}
                        </button>
                    </div>
                )}
            </div>
        );
        return <ReportExplainer isNotText textcontent={text} descriptionHidden={false} />;
    }
}

export default withTranslation()(ReportExplainerCompetitiveAnalysis);
